// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import SavedReplyConstants from 'constants/SavedReplyConstants'

const SavedReplyStore = Marty.createStore({
  id: 'SavedReplyStore',

  getInitialState() {
    return {
      // assuming we only see one org's saved replies in the app
      replyById: {}
    }
  },

  handlers: {
    fetchReplyListDone: SavedReplyConstants.REPLY_LIST_FETCH_DONE,
    fetchReplyDone: SavedReplyConstants.REPLY_FETCH_DONE,
    updateReplyDone: SavedReplyConstants.UPDATE_REPLY_DONE,
    setReplyToPopulate: SavedReplyConstants.SET_REPLY_TO_POPULATE
  },

  fetchReplyList() {
    return this.fetch({
      id: 'fetchReplyList',
      locally() {
        if (this.hasAlreadyFetched('fetchReplyList')) {
          return this.state.replyById
        }
      },
      remotely() {
        return this.app.queries.SavedReplyQueries.fetchReplies()
      }
    })
  },

  fetchReplyListSorted() {
    return this.fetch({
      id: 'fetchReplyListSorted',
      dependsOn: this.fetchReplyList(),
      locally() {
        return _.chain(this.state.replyById)
          .values()
          .sortBy('updatedAt')
          .reverse()
          .value()
      }
    })
  },

  fetchReplyListDone(replies) {
    let replyById = _.cloneDeep(this.state.replyById)
    replyById = _.assign(replyById, _.keyBy(replies, 'id'))
    return this.setState({ replyById })
  },

  fetchReply(replyId) {
    return this.fetch({
      id: `fetchReply${ replyId }`,
      locally() {
        return this.state.replyById[replyId]
      },
      remotely() {
        return this.app.queries.SavedReplyQueries.fetchReply(replyId)
      }
    })
  },

  fetchReplyDone(reply) {
    return this.setReply(reply)
  },

  updateReplyDone(reply) {
    return this.setReply(reply)
  },

  setReply(reply) {
    const replyById = _.cloneDeep(this.state.replyById)
    if (reply.status !== 'ARCHIVED') {
      replyById[reply.id] = reply
    // remove ARCHIVED replies
    } else {
      delete replyById[reply.id]
    }

    return this.setState({ replyById })
  },

  setReplyToPopulate(replyId) {
    return this.setState({ replyIdToPopulate: replyId })
  },

  getReplyToPopulate() {
    return this.state.replyById[this.state.replyIdToPopulate]
  }

})

export default SavedReplyStore



// WEBPACK FOOTER //
// ./src/scripts/stores/SavedReplyStore.js